import { Slider } from "@/components/ui/slider";
import { MIN_LEVERAGE, ABSOLUTE_MAX_LEVERAGE } from "@/solana/constants";

type LeverageSliderProps = {
  value: number;
  onChange: (value: number) => void;
  className?: string;
  /** Per-market max leverage from API. Falls back to ABSOLUTE_MAX_LEVERAGE if not provided. */
  max?: number;
};

export const LeverageSlider = ({
  value,
  onChange,
  className,
  max,
}: LeverageSliderProps) => {
  // Use API-provided max or fall back to absolute system maximum
  const maxLeverage = max ?? ABSOLUTE_MAX_LEVERAGE;
  
  return (
    <div className={className}>
      <div className="flex items-center justify-between mb-2">
        <label className="text-sm font-medium">Leverage</label>
        <span className="text-sm font-medium">{value}x</span>
      </div>
      <Slider
        value={[value]}
        onValueChange={(values) => onChange(values[0])}
        min={MIN_LEVERAGE}
        max={maxLeverage}
        step={1}
        className="w-full"
      />
      <div className="flex justify-between mt-1">
        <span className="text-xs text-muted-foreground">{MIN_LEVERAGE}x</span>
        <span className="text-xs text-muted-foreground">{maxLeverage}x</span>
      </div>
    </div>
  );
};

